module.exports = __webpack_public_path__ + "lu.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/lu.svg
// module id = 924
// module chunks = 0